import { HandbookContent } from './loaders';

export const Handbook = () => <HandbookContent />;
